module.exports = __webpack_public_path__ + "static/media/muley_turner_fernandez_marshall.75d15882.jpg";